import { VSpacer } from 'vuetify/lib'
import { SELECT_FIELD } from '../type_name'
export default {
    name: SELECT_FIELD,
    props: {
        field: {
            type: Object,
        },
        value: {
            type: Object
        }
    },
    computed: {
        fieldHash() {
            const { items, value_key } = this.field
            return (items || []).reduce((total, item) => {
                total[item[value_key]] = item
                return total
            }, {})
        }
    },
    methods: {
        // 生成 VSpacer
        setVSpacer(h) {
            if (this.vSpacer) {
                return this.vSpacer
            }
            return this.vSpacer = h(VSpacer)
        }
    },
    render(h) {
        const { 
             label,
             key, 
             textRender,
             initText = '-',
             text_key = '',
             default_value = '-'
            } = this.field
        let text = initText
        if (textRender) {
            text = textRender({h, field:this.field, value:this.value})
        } else if (this.value[key]) {
            text = (this.fieldHash[this.value[key]] && this.fieldHash[this.value[key]][text_key]) || default_value
        } 
        return h('div', {
            style: {
                width: '100%',
                display: 'flex'
            }
        }, [
            h('span', {
                style:{
                    'white-space':'nowrap',
                    'margin-right': '10px'
                }
            }, label),
            this.setVSpacer(h),
            text
        ])
    }
}